module.exports = __webpack_public_path__ + "media/images/undraw/matching/export_files-35a9db1d1f9f641f0b5f89e9f22aca2e.png";